module.exports = __webpack_public_path__ + "img/title4.a42d22ca.png";